import { render, staticRenderFns } from "./post_suggestions.vue?vue&type=template&id=13dcc561&scoped=true&"
import script from "./post_suggestions.vue?vue&type=script&lang=js&"
export * from "./post_suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcc561",
  null
  
)

export default component.exports